import React, { useState, useEffect } from 'react';
import ScrollToTop from '../components/ScrollToTop';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import { Account } from '../components/Accounts';
import MyLibrary from '../components/MyLibrary';
import Sidebar from '../components/Sidebar';
function Library() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Account>
      <ScrollToTop />
      <Sidebar isOpen={isOpen} toggle={toggle} isHeader={true} />
      <Navbar toggle={toggle} isHeader={true} />
      <MyLibrary />
      <Footer />
    </Account>
  );
}

export default Library;
